import Formatter from "./Formatter";

export function getRefAreasForCategoryBarChart(data) {
	return data.map(({ x }, idx) => (idx % 2 === 0 ? { x1: x, x2: data[idx + 1] ? data[idx + 1].x : undefined } : null)).filter((r) => !!r);
}
export const MONTH_YEAR_TIME_FRAMES = { MONTHS: "Months", YEARS: "Years" };
export const MONTH_YEAR_TIME_FRAME_LIST = [MONTH_YEAR_TIME_FRAMES.MONTHS, MONTH_YEAR_TIME_FRAMES.YEARS];
export const Y_AXIS_PROPS = { tickFormatter: (v) => Formatter.asMoney(v, 0), width: 80 };
